<template>
    <div>
        <router-view name="demandModal"></router-view>
        <v-card
            class="mx-auto"
            min-height="100%"
            :loading="isLoading"
        >
            <!-- Filtros -->
            <v-container fluid class="pb-0">
                <v-row class="d-flex align-center justify-center">
                    <v-col cols="12" sm="4" md="3">
                        <v-text-field
                            v-model="query"
                            @click:clear="clearQuery"
                            @keyup.enter="loadData()"
                            type="text"
                            prepend-icon="search"
                            :label="$t('notifications.filter.searchFor')"
                            clear-icon="cancel"
                            clearable
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                        <input-auto-complete :setup.sync="selects.client"></input-auto-complete>
                    </v-col>
                    <v-col cols="12" sm="4" md="3" v-if="active === 2">
                        <input-auto-complete :setup.sync="selects.responsible"></input-auto-complete>
                    </v-col>
                    <div class="d-flex justify-end">
                        <v-btn
                            color="error"
                            class="mr-1"
                            text
                            small
                            :disabled="!ready"
                            @click="clearFilters"
                        >{{ $t('notifications.filter.clearFilter') }}</v-btn>
                        <v-btn
                            color="primary"
                            class="ml-1"
                            small
                            :disabled="!ready"
                            @click="loadData()"
                        >{{ $t('notifications.filter.applyFilter') }}</v-btn>
                    </div>
                    <v-col cols="12" class="pl-0 pr-0 pb-0">
                        <v-divider></v-divider>
                    </v-col>
                </v-row>
            </v-container>
            <!-- /Filtros -->
            <v-container fluid class="pa-0 mr-0 content-container">
                <v-row no-gutters>
                    <!-- Caixas -->
                    <v-col cols="12" sm="4" md="2">
                        <v-navigation-drawer
                            permanent
                            width="100%"
                        >
                            <v-list-item>
                                <v-list-item-title>{{ $t('notifications.sideMenu.boxes') }}</v-list-item-title>
                            </v-list-item>

                            <v-list dense>
                                <div v-for="(item, i) in items" :key="item.objectId">
                                    <v-list-item
                                        v-if="(isAdmin || item.adminOnly === false)"
                                        link
                                        :class="[i === active ? 'isActive' : '']"
                                        @click="loadData({active: i})"
                                    >
                                        <v-list-item-icon :class="[i === active ? 'isActive' : '']">
                                            <v-icon :color="i === active ? 'white' : ''" >{{ item.icon }}</v-icon>
                                        </v-list-item-icon>

                                        <v-list-item-content>
                                            <v-list-item-title :class="[i === active ? 'isActive' : '']">
                                            <v-badge
                                                v-if="item.badge && item.badge > 0"
                                                color="green"
                                                :content="item.badge"
                                                right
                                                overl ap
                                            >
                                                {{ item.title }}
                                            </v-badge>
                                                <div v-else>{{ item.title }}</div>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </div>
                            </v-list>
                        </v-navigation-drawer>
                        <v-divider></v-divider>
                    </v-col>
                    <!-- /Caixas -->
                    <v-col cols="12" sm="8" md="10">
                        <div class="display-flex align-center">
                            <!-- Toolbar e paginação -->
                            <v-toolbar dense flat>
                                <v-checkbox v-if="active === 0 || active === 2" v-model="allNotifications" hide-details></v-checkbox>
                                <v-btn :class="[active === 0 || active === 2 ? '' : 'ml-3']" icon x-small @click="loadData({active})"><v-icon>refresh</v-icon></v-btn>
                                <v-menu v-if="active === 0 || active === 2" bottom right>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            icon
                                            v-on="on"
                                            x-small
                                        >
                                            <v-icon>mdi-dots-vertical</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list >
                                        <v-list-item @click="setAllRead()">
                                            <v-list-item-title >{{ $t('notifications.dotMenu.markAllRead') }}</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item @click="setAllStore()">
                                            <v-list-item-title >{{ $t('notifications.dotMenu.archiveAll') }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                                <v-spacer></v-spacer>
                                <span class="pr-3">{{totalNotifcations === 0 ? 0 : (itemsPerPage * page) + 1}}-{{(itemsPerPage * (page + 1)) > totalNotifcations ? totalNotifcations : itemsPerPage * (page + 1)}} de {{totalNotifcations}}</span>
                                <v-btn icon x-small :disabled="page === 0" @click="previousPage()"><v-icon>navigate_before</v-icon></v-btn>
                                <v-btn icon x-small :disabled="this.totalNotifcations <= (this.itemsPerPage * (this.page + 1))" @click="nextPage()"><v-icon>navigate_next</v-icon></v-btn>
                            </v-toolbar>
                            <!-- /Toolbar e paginação -->
                        </div>
                        <v-divider></v-divider>
                        <div class="notifications-content">
                            <template v-if="notifications.length === 0 && !isLoading">
                                <v-list-item-content :rounded="false">
                                    <v-list-item-title
                                        class="noItem"
                                    >{{ $t('common.dataTable.noDataText') }}</v-list-item-title>
                                </v-list-item-content>
                            </template>
                            <template v-for="(item) in notifications">
                                <notification-tile  @saveSelected="saveSelected" @refreshBadgeNotifications="getNumberNotifications" @filterNotifications="filterNotifications" :key="item.objectId" :notification="item" :type="items[active].type"/>
                            </template>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </div>
</template>

<script>
import API from '@/api'
import InputAutoComplete from '@/components/InputAutoComplete'
import NotificationTile from '@/components/notification/NotificationTile'

export default {
    name: 'list-notifications',
    metaInfo () {
        return {
            title: this.$t('notifications.meta.title'),
            meta: [
                { name: 'description', content: this.$t('notifications.meta.description') },
                { name: 'keywords', content: this.$t('notifications.meta.keywords') }
            ]
        }
    },
    components: {
        InputAutoComplete,
        NotificationTile
    },
    data () {
        return {
            isAdmin: false,
            totalNotifcations: 0,
            isLoading: false,
            page: 0,
            itemsPerPage: 50,
            active: 0,
            hoverNotification: '',
            ready: true,
            query: undefined,
            items: [
                { index: 0, title: this.$t('notifications.sideMenu.my'), icon: 'mdi-home-city', type: 'myNotifications', adminOnly: false, employeeOnly: false, badge: '' },
                { index: 1, title: this.$t('notifications.sideMenu.distribution'), icon: 'mdi-account', type: 'distributionNotifications', adminOnly: false, employeeOnly: true, badge: '' },
                { index: 2, title: this.$t('notifications.sideMenu.admin'), icon: 'mdi-account-group', type: 'adminNotifications', adminOnly: true, employeeOnly: true },
                { index: 3, title: this.$t('notifications.sideMenu.archived'), icon: 'archive', type: 'archiveNotifications', adminOnly: false, employeeOnly: false, badge: '' },
                { index: 4, title: this.$t('notifications.sideMenu.archivedAdmin'), icon: 'archive', type: 'adminArchiveNotifications', adminOnly: true, employeeOnly: true }
            ],
            selects: {
                client: {
                    label: this.$t('notifications.filter.byDepartment'),
                    text: 'name',
                    value: 'objectId',
                    icon: 'contacts',
                    multiple: true,
                    clearable: true,
                    items: [],
                    selectedItems: []
                },
                responsible: {
                    label: this.$t('notifications.filter.byResponsible'),
                    text: 'user.name',
                    value: 'objectId',
                    icon: 'person',
                    multiple: true,
                    clearable: true,
                    items: [],
                    selectedItems: []
                }
            },
            search: {
                ready: true,
                query: ''
            },
            allNotifications: false,
            notifications: []
        }
    },
    watch: {
        allNotifications () {
            this.notifications.map((notification) => {
                notification.selected = this.allNotifications
            })
        },
        '$root.newNotification': {
            handler: function (val, oldVal) {
                if (oldVal !== val && val !== undefined) {
                    if (this.$root.notificaitonId !== undefined) this.loadData({ id: this.$root.notificaitonId })
                    this.getNumberNotifications()
                    this.$root.notificaitonId = undefined
                    this.$root.newNotification = false
                }
            },
            deep: true
        }
    },
    async mounted () {
        this.getAllClient()
        this.getAllEmployee()
        this.adminOnly()
        await this.loadData({ active: this.active })
        this.getNumberNotifications()
        this.$root.newNotification = false
    },
    computed: {
        isEmployee: function () {
            return window.getApp.isEmployee
        }
    },
    methods: {
        adminOnly () {
            if (this.$helpers.isAdmin()) {
                this.isAdmin = true
            }
        },
        filterNotifications (id) {
            this.notifications = this.notifications.filter((notification) => {
                return notification.objectId !== id
            })
        },
        async getAllClient () {
            this.selects.client.items = await this.$helpers.getAllClient(null, false, true)
        },
        nextPage () {
            this.page = this.page + 1
            this.loadData({ active: this.active })
        },
        previousPage () {
            this.page = this.page - 1
            this.loadData({ active: this.active })
        },
        saveSelected () {
            this.$helpers.setnotificationSelected(this.active)
        },
        getNumberNotifications () {
            const notificationsNumber = this.$root.notifications
            if (notificationsNumber) {
                this.items.forEach((item) => {
                    if (item.index === 0) item.badge = notificationsNumber.myNumber.toString()
                    if (item.index === 1) item.badge = notificationsNumber.distributionNumber.toString()
                    if (item.index === 2) item.badge = notificationsNumber.storedNumber.toString()
                })
            }
        },
        async loadData (filter) {
            await this.$helpers.sleep(0)
            const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            this.allNotifications = false
            this.isLoading = true

            let id = (filter && filter.id) ? filter.id : null
            this.notifications = (filter && filter.id) ? this.notifications : []
            this.active = (filter && (filter.active || filter.active === 0)) ? filter.active : this.active
            let notificationSelected = JSON.parse(localStorage.getItem('notificationSelected'))
            if (notificationSelected !== null) {
                this.active = JSON.parse(localStorage.getItem('notificationSelected'))
            }

            this.$helpers.setnotificationSelected(null)

            const params = {
                type: this.items[this.active].type,
                client: this.selects.client.selectedItems,
                responsible: this.selects.responsible.selectedItems,
                responsibles: this.selects.responsible.selectedItems,
                limit: this.itemsPerPage,
                skip: this.page,
                query: this.query,
                id: id,
                organizationId: currentUserCompany.client.objectId
            }
            let endpoint = API.EndPoints.getNotification
            new API(endpoint, params).request().then(response => {
                if (id !== null && response.data.result.items.length) {
                    this.notifications.splice(0, 0, response.data.result.items)
                    if (this.notifications.length === this.itemsPerPage) {
                        this.notifications.pop()
                    } else {
                        this.totalNotifcations++
                    }
                } else if (response.data.result.items.length) {
                    this.notifications = response.data.result.items.map((notification) => {
                        return { ...notification, selected: false }
                    })
                    this.totalNotifcations = response.data.result.count
                }
                this.isLoading = false
            }, (e) => {
                this.$helpers.requestError(e)
                this.isLoading = false
            })
        },
        async getAllEmployee () {
            this.selects.responsible.items = await this.$helpers.getAllEmployee()
        },
        clearFilters () {
            this.selects.client.selectedItems = []
            this.loadData({ active: this.active })
        },
        clearQuery () {
            this.search.query = ''
            this.loadData()
        },
        setAllRead () {
            const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            let selectedItems = []

            this.notifications.forEach((notification) => {
                if (notification.selected) {
                    selectedItems.push(notification.objectId)
                }
            })

            let endpoint = API.EndPoints.setNotification
            let params = {
                action: 'read',
                id: selectedItems,
                organizationId: currentUserCompany.client.objectId
            }

            new API(endpoint, params).request().then(response => {
                this.notifications.forEach((notification) => {
                    if (notification.selected) {
                        notification.itWasRead = !notification.itWasRead
                        notification.selected = false
                    }
                })
                this.allNotifications = false
                this.$root.refreshBadgeNotifications = true
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        setAllStore () {
            const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            let selectedItems = []

            this.notifications.forEach((notification) => {
                if (notification.selected) selectedItems.push(notification.objectId)
            })

            let endpoint = API.EndPoints.setNotification
            let params = {
                action: 'store',
                id: selectedItems,
                organizationId: currentUserCompany.client.objectId
            }

            new API(endpoint, params).request().then(response => {
                this.loadData({ active: this.active })
                this.allNotifications = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
    .content-container
        .row
            @media (min-width: 768px) {
                height: calc(100vh - 310px)
            }

    .isActive
        background-color: #1976D2
        color: white

    .noItem
        display flex
        justify-content center
        color  rgba(0, 0, 0, 0.38)
        border-bottom: 1px solid #C9C9C9;
        padding-top 5px
        padding-bottom 15px
        font-size 14px

    .notifications-content
        max-height: calc(100vh - 360px)
        padding: 0 0 10px 0;
        overflow-y: scroll

    .isActiveIcon
        color: white
</style>
